// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MOan","largestCol":"styles_largestCol__5utlT","smallestCol":"styles_smallestCol__xH9ei"};